// Config
import localeConfig from '../config/locale-config'
import lodgingTypeConfig, { LocaleLodgingTypeConfig } from '../config/lodging-type-config'

function getLodgingTypesByLocale(locale: string): LocaleLodgingTypeConfig {
    if (!locale) throw new Error('locale is mandatory in getLodgingTypesByLocale')
    if (!localeConfig.has(locale)) throw new Error('invalid locale, does not exist in localeConfig in getLodgingTypesByLocale')

    return lodgingTypeConfig[locale]
}

export default getLodgingTypesByLocale
